'use strict';

module.exports = function normalizeReference(str) {
  // use .toUpperCase() instead of .toLowerCase()
  // here to avoid a conflict with Object.prototype
  // members (most notably, `__proto__`)
  return str.trim().replace(/\s+/g, ' ').toUpperCase();
};



//////////////////
// WEBPACK FOOTER
// ./~/remarkable/lib/helpers/normalize_reference.js
// module id = 502
// module chunks = 0